var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNordicZoomIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.794,
    height: 26.793,
    viewBox: "0 0 26.794 26.793",
    style: {
      color: "#7d6630"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-196.606 -1206.055)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.601 2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.327,23.326a1.675,1.675,0,0,1,2.37,0l6.447,6.447a1.675,1.675,0,1,1-2.367,2.37L23.329,25.7a1.675,1.675,0,0,1,0-2.37Z",
    transform: "translate(191.365 1198.215)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.885,20.095a9.21,9.21,0,1,0-9.21-9.21A9.21,9.21,0,0,0,10.885,20.095Zm10.885-9.21A10.885,10.885,0,1,1,10.885,0,10.885,10.885,0,0,1,21.769,10.885Z",
    transform: "translate(197.206 1204.055)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1010.409 -240.284)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 8,
    transform: "translate(1214.5 1455.618)",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    y2: 8.235,
    transform: "translate(1218.5 1451.5)",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNordicZoomIn);
export default __webpack_public_path__ + "static/media/nordic_zoom_in.9a31a4dfd08fb78929ed50f4b62fbb38.svg";
export { ForwardRef as ReactComponent };